<template>
  <div class="col-md-12 bg-gray-50 border-radius">
    <div class="wrapper-content-15">
      <div class="row">
        <div class="col-md-12">
          <h4>Familia de Geradores Solar</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-12">
          <div class="border-radius border-gray-solid">
            <div class="d-flex d-flex-just-beteween wrapper-content">
              <h5>Histórico de Utilização em Projetos</h5>
              <Select2
                v-model="FamiliaAno"
                :options="Anos"
                :settings="{  }"
                @select="FamiliaAnoSelect($event)"
              />
            </div>
            <Loader v-if="!HistoricoKitsReload" />            
            <line-chart
              :chartData="HistoricoKits"
              v-if="HistoricoKitsReload && HistoricoKits.datasets.length > 0"
              :options="optionsKits"
              chart-id="bar-HistoricoKits"
              :height="'300'"
            ></line-chart>
            <div class="text-center" v-else-if="HistoricoKitsReload">
              <h4>Sem Dados Para Exibição</h4>
            </div>
          </div>
        </div>
        <!-- <div class="col-xs-12 col-md-6">
          <div class="border-radius border-gray-solid">
            <div class="wrapper-content">
              <h5>Funil de Vendas</h5>
              <div class="row">
                <div class="col-md-12 mb30">
                  <FunnelChart
                    v-if="this.funil.labels"
                    :labels="this.funil.labels"
                    :dataChart="this.funil.data"
                    chart-id="bar-funil"
                  ></FunnelChart>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Select2 from "v-select2-component";
import axios from "axios";
import FunnelChart from "../Components/FunnelChart.vue";
import LineChart from "../Components/LineChart.vue";

export default {
  components: {
    Select2,
    axios,
    FunnelChart,
    LineChart
  },
  data() {
    return {
      FamiliaAno: 2019,
      HistoricoKitsReload :false,
      HistoricoKits: {
        labels: [
          "JAN",
          "FEV",
          "MAR",
          "ABR",
          "MAI",
          "JUN",
          "JUL",
          "AGO",
          "SET",
          "OUT",
          "NOV",
          "DEZ"
        ],
        datasets: null
      },
      optionsKits: {
        animation : {
          duration : 0
        },
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 30,
            bottom: 20
          }
        },
        plugins: {
          datalabels: {
            color: "rgba(0,0,0,0)",
            labels: {
              title: {
                align: "top"
              }
            }
          }
        },
        legend: {
          display: true,
          position: "bottom"
        },
        scales: {
          yAxes: [
            {
              display: true,
              gridLines: {
                display: true
              },
              ticks: {
							  beginAtZero: true
					  	}
            }
          ],
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false
              }
            }
          ]
        }
      },
      funil: {
        data: null,
        labels: null
      }
    };
  },
  props: ["Anos"],
  mounted() {
    this.fillHistoryFamilys();
    //this.fillFunil();
  },
  methods: {
    FamiliaAnoSelect: function(val) {
      this.FamiliaAno = val.id;
      this.fillHistoryFamilys();
    },
    // fillFunil: function() {
    //   let self = this;



    //   axios
    //     .get(this.$apiUrl + "Projeto.svc/dashboard/gestaoaldo/ProjetoFunil")
    //     .then(function(response) {
    //       self.funil.labels = response.data.labels;
    //       self.funil.data = response.data.data;

    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    // },
    fillHistoryFamilys: function() {
      let self = this;

      self.HistoricoKitsReload = false;

      axios
        .get(
          this.$apiUrl +
            `Projeto.svc/dashboard/gestaoaldo/GestaoAldo_UsoFamilias?ano=${self.FamiliaAno}`
        )
        .then(function(response) {
          self.HistoricoKits.datasets = [];

          let colors = [
            "rgba(175,238,238,0.4)",
            "rgba(250,250,210,0.4)",
            "rgba(152,251,152,0.4)",
            "rgba(135,206,235,0.4)",
            "rgba(176,224,230,0.4)",
            "rgba(238,232,170,0.4)",
            "rgba(230,230,250,0.4)"
          ];

          let colorsLine = [
            "rgb(130,193,193)",
            "rgb(205,205,165)",
            "rgb(107,206,107)",
            "rgb(90,161,190)",
            "rgb(131,179,185)",
            "rgb(193,187,125)",
            "rgb(185,185,205)"
          ];

          for (let index = 0; index < response.data.length; index++) {
            const element = response.data[index];
            self.HistoricoKits.datasets.push({
              backgroundColor: colors[index],
              borderColor: colorsLine[index],
              borderWidth: 2,
              pointBorderWidth: 2,
              pointBorderColor: colorsLine[index],
              pointBackgroundColor: colorsLine[index],
              data: element.Qtde,
              label: element.Nome
            });
          }

          self.HistoricoKitsReload = true;


        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>